import { ReactNode } from "react";
import Icon from "../../components/Icon";
import Add from "../../components/icons/add.svg?react";
import Remove from "../../components/icons/remove.svg?react";
import useToggle from "../../hooks/useToggle";
import styles from "./Faqs.module.css";

interface Faq {
  question: string;
  answer: ReactNode;
}

interface Props {
  faqs: Faq[];
}

const Faqs = ({ faqs }: Props) => {
  return (
    <dl>
      {faqs.map((faq, i) => {
        const { isOpen, toggle } = useToggle();
        return (
          <div key={i} className={styles.questionWrapper}>
            <dt onClick={() => toggle()} className={styles.question}>
              <span>{faq.question}</span>
              <Icon glyph={!isOpen ? Add : Remove} className={styles.arrow} />
            </dt>
            {isOpen && <dd className={styles.answer}>{faq.answer}</dd>}
          </div>
        );
      })}
    </dl>
  );
};

export default Faqs;
